import ReactQuill, { Quill } from 'react-quill';
import CustomImageBlot from './CustomImageBlot';

import './CustomImageBlot/custom-image.scss';

if (!Quill.imports['formats/customImage']) {
  Quill.register(CustomImageBlot);
}
